var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBucket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4602 3.29667C11.3002 2.82 10.8568 2.5 10.3535 2.5H5.98016C5.47683 2.5 5.0335 2.82 4.8735 3.29667L4.0835 5.66667H5.13683L5.82016 3.61333C5.8435 3.54667 5.90683 3.5 5.97683 3.5H10.3502C10.4235 3.5 10.4868 3.54667 10.5068 3.61333L11.1902 5.66667H12.2435L11.4535 3.29667H11.4602Z",
    fill: "#2D3958"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6668 6.5H2.66683C2.4835 6.5 2.3335 6.65 2.3335 6.83333V8.5C2.3335 8.68333 2.4835 8.83333 2.66683 8.83333H3.24016L3.9135 13.2667C3.9635 13.5933 4.2435 13.8333 4.5735 13.8333H11.7602C12.0902 13.8333 12.3702 13.5933 12.4202 13.2667L13.0968 8.83333H13.6702C13.8535 8.83333 14.0035 8.68333 14.0035 8.5V6.83333C14.0035 6.65 13.8535 6.5 13.6702 6.5H13.6668ZM6.3335 12C6.3335 12.2767 6.11016 12.5 5.8335 12.5C5.55683 12.5 5.3335 12.2767 5.3335 12V9.83333C5.3335 9.55667 5.55683 9.33333 5.8335 9.33333C6.11016 9.33333 6.3335 9.55667 6.3335 9.83333V12ZM8.66683 12C8.66683 12.2767 8.4435 12.5 8.16683 12.5C7.89016 12.5 7.66683 12.2767 7.66683 12V9.83333C7.66683 9.55667 7.89016 9.33333 8.16683 9.33333C8.4435 9.33333 8.66683 9.55667 8.66683 9.83333V12ZM11.0002 12C11.0002 12.2767 10.7768 12.5 10.5002 12.5C10.2235 12.5 10.0002 12.2767 10.0002 12V9.83333C10.0002 9.55667 10.2235 9.33333 10.5002 9.33333C10.7768 9.33333 11.0002 9.55667 11.0002 9.83333V12Z",
    fill: "#2D3958"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBucket);
export default __webpack_public_path__ + "static/media/bucket.d4b13b8088170fb5b6cfcb019cb6fb6a.svg";
export { ForwardRef as ReactComponent };